import { removeAccents } from '@arnold/core';

interface HighlightTextProps {
  text: string;
  query: string;
}

export const HighlightText = ({ text, query }: HighlightTextProps) => {
  if (!query) return <>{text}</>;

  const normalizedText = removeAccents(text).toLowerCase();
  const normalizedQuery = removeAccents(query).toLowerCase();
  const index = normalizedText.indexOf(normalizedQuery);

  if (index === -1) return <>{text}</>;

  return (
    <>
      {text.slice(0, index)}
      <strong>{text.slice(index, index + normalizedQuery.length)}</strong>
      {text.slice(index + normalizedQuery.length)}
    </>
  );
};
